import { useAuth } from "@/context/authContext";
import { api } from "@/utils/api";
import { useState, type Dispatch, type SetStateAction } from "react";

export const useLoadDashboard = () => {
  const { dispatch } = useAuth();
  const [loading, setLoading] = useState<{
    openSignups: boolean;
    upcomingExplorations: boolean;
    attendance: boolean;
  }>({ openSignups: false, upcomingExplorations: false, attendance: false });

  const loadOpenSignups = async (
    setOpenSignups: Dispatch<
      SetStateAction<{
        sessions: any[];
        rotations: any[];
      }>
    >,
  ) => {
    try {
      setLoading((prev) => ({ ...prev, openSignups: true }));
      const response = await api(
        "/dashboard/student/open-sessions",
        { method: "GET" },
        dispatch,
      );
      setOpenSignups({
        sessions: response.sessions,
        rotations: response.rotations,
      });
    } catch (error: any) {
    } finally {
      setLoading((prev) => ({ ...prev, openSignups: false }));
    }
  };

  const loadUpcomingExplorations = async (
    setUpcomingExplorations: Dispatch<
      SetStateAction<{
        explorations: any[];
        rotations: any[];
        sessions: any[];
        teachers: any[];
      }>
    >,
  ) => {
    try {
      setLoading((prev) => ({ ...prev, upcomingExplorations: true }));
      const response = await api(
        "/dashboard/student/upcoming-explorations",
        { method: "GET" },
        dispatch,
      );
      setUpcomingExplorations({
        explorations: response.explorations,
        rotations: response.rotations,
        sessions: response.sessions,
        teachers: response.teachers,
      });
    } catch (error: any) {
    } finally {
      setLoading((prev) => ({ ...prev, upcomingExplorations: false }));
    }
  };

  const loadAttendance = async (
    setAttendance: Dispatch<
      SetStateAction<{
        total: { records: number; present: number };
        rotations: any[];
      } | null>
    >,
  ) => {
    try {
      setLoading((prev) => ({ ...prev, attendance: true }));
      const response = await api(
        "/dashboard/student/attendance",
        { method: "GET" },
        dispatch,
      );
      setAttendance({
        total: response.data.total,
        rotations: response.data.rotations,
      });
    } catch (error: any) {
    } finally {
      setLoading((prev) => ({ ...prev, attendance: false }));
    }
  };

  return { loadOpenSignups, loadUpcomingExplorations, loadAttendance, loading };
};
